import { Component, OnInit, ChangeDetectionStrategy, ViewChild, TemplateRef } from '@angular/core';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { AppointmentService } from './appointment.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { resetFakeAsyncZone } from '@angular/core/testing';


const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.scss']
})
export class AppointmentComponent implements OnInit {

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  @ViewChild('addEventModal', { static: true }) addEventModal: TemplateRef<any>;
  appoinmentSlotEvent: CalendarEvent[] = [];
  dropdownSettings: IDropdownSettings;
  submitted = false;
  //calendar slot colors
  colors: any = {
    0: {
      primary: '#23C9FF'
    }, 1: {
      primary: '#FFCAD4'
    }, 2: {
      primary: '#C08497'
    }, 3: {
      primary: '#F7AF9D'
    }, 4: {
      primary: '#F2D492'
    }, 5: {
      primary: '#D4E5CC'
    }, 6: {
      primary: '#ADA8B6'
    }, 7: {
      primary: '#946E83'
    }, 8: {
      primary: '#A4B0F5'
    }
  };

  selected = undefined;
  selectedColor = '';

  eventPriorityColors = [
    {
      name: 'Select',
      value: ''
    },
    {
      name: 'Yellow',
      // value: '#ffff00'
    },
    {
      name: 'Red',
      // value: '#ff3300'
    },
    {
      name: 'Blue',
      // value: '#0000ff'
    }
  ];

  appForm: FormGroup;
  memberList = [{ id: 1, name: "Test Member 1" }, { id: 2, name: "Test Member 2" }]

  constructor(private modal: NgbModal, private appointmentService: AppointmentService, private formBuilder: FormBuilder
    , private toastrService: ToastrService) {
    this.getFormGroup();
  }

    /**
   * To get form controls
   */
  get f() { return this.appForm.controls; }
  /**
 * Declare form group
 *  
 */
  private getFormGroup() {
    this.appForm = this.formBuilder.group({
      'appCaption': ['', Validators.required],
      'appDescription': new FormControl(),
      'appColor': new FormControl(),
      'appStartDate': ['', Validators.required],
      'appEndDate': ['', Validators.required],
      'patieId': new FormControl(),
      'memb': new FormControl()
    })
  }


  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  refresh: Subject<any> = new Subject();
  activeDayIsOpen: boolean = false;
  modalData: {
    action: string;
    event: CalendarEvent;
  };
  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('Deleted', event);
      },
    },
  ];

  events: CalendarEvent[];/* = [
      {
        start: subDays(startOfDay(new Date()), 1),
        end: addDays(new Date(), 1),
        title: 'Event 1',
        color: colors.red,
        actions: this.actions,
        allDay: true,
        resizable: {
          beforeStart: true,
          afterEnd: true,
        },
        draggable: true,
      },
      {
        start: startOfDay(new Date()),
        title: 'Event 2',
        color: colors.yellow,
        actions: this.actions,
      },
      {
        start: addHours(startOfDay(new Date()), 2),
        end: addHours(new Date(), 2),
        title: 'Event 3',
        color: colors.yellow,
        actions: this.actions,
        resizable: {
          beforeStart: true,
          afterEnd: true,
        },
        draggable: true,
      },
    ];
   */




  ngOnInit() {
    /*  this.appointmentService.getAppointmentById(1).subscribe(res=>{
       console.log("res :"+JSON.stringify(res));
     }) */
    this.getAppointmentSlots();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      //itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }


  /**
  * To get appoinment slots based on the search parameter provided.
  */
  getAppointmentSlots() {
    let colorIndex = 0;
    this.events = [];
    let appoinmentSlot: CalendarEvent;

    this.appointmentService.getAppointmentById(1).subscribe(res => {
      if (res && res['result']) {
        let appoinmentSlots = res['result'];
        //  var calenderSlots = this.formatAppoimentSlotsToCalendar();
        appoinmentSlots.forEach((slot, index) => {
          appoinmentSlot = {
            start: new Date(slot.appStartDate), end: new Date(slot.appEndDate), title: slot.appCaption, color: this.colors[colorIndex++], meta: slot
          }
          this.appoinmentSlotEvent.push(appoinmentSlot);
        });
      }
      this.events = this.appoinmentSlotEvent;
    })
  }



  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
    this.modal.open(this.modalContent, { container: '.page-content' });
  }

  addNewEventModal() {
    this.reset();
    this.submitted = false;
    this.modal.open(this.addEventModal, { container: '.page-content' });
  }

  addEvent(): void {
    this.events = [
      ...this.events,
      {
        title: 'New event',
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
        color: colors.red,
        draggable: true,
        resizable: {
          beforeStart: true,
          afterEnd: true,
        },
      },
    ];
  }

  saveAppointment() {
    this.submitted = true;
    if (this.appForm.invalid) {
      return;
    }
    this.appForm.patchValue({ patieId: 1 });
    this.appointmentService.saveApp(this.appForm.value).subscribe(res => {
      if (res) {
        this.toastrService.success("Event added Succesfully");
        this.getAppointmentSlots();
        this.modal.dismissAll(this.addEventModal);
      }
    })
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }
  reset(){
    this.appForm.reset();
  }
}
